import React, { FunctionComponent } from 'react';
import { useTheme } from '@material-ui/styles';
import { ISelectedFeaturesListProps } from '../SelectedFeaturesList';
import { ISpcTheme } from '../../../../../../../../../common/theme/ISpcTheme';
import SelectedColorOption from '../../../../../simpleBrands/summary/summaryAdditionalSelections/selectedFeatures/selectedFeatureOption/SelectedColorOption';
import SelectedOption from './SelectedOption';
import CategoryPurpose from '../../../../../../../../enum/CategoryPurpose';

const SelectedFeatureOption: FunctionComponent<ISelectedFeaturesListProps> = ({
  featuresList,
  sectionCode,
  sectionType,
  categoryPurpose,
}) => {
  const {
    spc: {
      customise: { displayColorButtonOnSummary },
    },
  } = useTheme<ISpcTheme>();
  const showColorButton =
    displayColorButtonOnSummary &&
    (categoryPurpose === CategoryPurpose.EXTERIOR_COLOUR || categoryPurpose === CategoryPurpose.INTERIOR_COLOUR);

  if (showColorButton) {
    return <SelectedColorOption key={sectionCode} featuresList={featuresList} sectionName={sectionCode} />;
  }

  return (
    <>
      {featuresList.features.map((feature, index) => (
        <SelectedOption sectionCode={sectionCode} feature={feature} sectionType={sectionType} key={index} />
      ))}
    </>
  );
};

export default SelectedFeatureOption;
